/**
 * «Mi cuenta» outside a restaurant (a franchise director, the platform) opens rarely, so it loads apart from the
 * Panel's entry; a restaurant reaches it inside Configuración, which loads it with its own screen.
 */
import { lazy, Suspense } from 'react';
import type { AccountSettingsProps } from './account';
import { LoadingRegion } from './state';

const LazyAccountSettings = lazy(() => import('./account').then((module) => ({ default: module.AccountSettings })));

export function AccountSettings(props: AccountSettingsProps) {
  return <Suspense fallback={<LoadingRegion label="Cargando tu cuenta" />}><LazyAccountSettings {...props} /></Suspense>;
}
